export default __webpack_public_path__ + "static/media/nft-background.6e3c48d4.svg";